import { FormBuilderComponent } from '../../../../components/form-builder/form-builder.component';
import { DynamicForm } from '../../../../components/form-builder/form-builder.types';
import { AddressRepository } from '../../../../store/address-state/address-state.repository';
import { DrawerObject } from '../../../../components/drawer/drawer.types';

interface getAddressAddDrawerObjectProps {
  store?: AddressRepository;
  formObject?: DynamicForm;
  toggleVisibility?: () => void;
  action?: () => void;
}

export const getAddressAddDrawerObject = ({ store, formObject, toggleVisibility, action }: getAddressAddDrawerObjectProps): DrawerObject => {
  return {
    title: 'settings.address.add.title',
    description: 'settings.address.add.description',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject: formObject,
      },
    },
    actions: [
      {
        label: 'settings.address.add.add',
        onClick: () => action?.(),
      },
      {
        label: 'settings.address.add.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
